// Own module rather than SubscriptionPurchase.jsx: PricingArea.test.jsx mocks that component
// wholesale, which would make the constant undefined inside PricingArea.
const PURCHASE_OPTION = {
  SUBSCRIPTION: 'subscription',
  ONETIME: 'onetime',
}

export default PURCHASE_OPTION
